import React, { useState, useCallback, useEffect } from 'react'
import { Button, ButtonGroup, Grid, Menu, MenuItem, withStyles, ListItemIcon, ListItemText, Dialog, DialogTitle, DialogContent, DialogContentText, colors, DialogActions } from '@material-ui/core'
import useRouter from 'utils/useRouter'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import AddCommentIcon from '@material-ui/icons/AddComment'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn'
import { makeStyles } from '@material-ui/styles'
import { useCasoService } from 'hooks/useCasoService'
import { SelectDespacho } from 'components/SelectDespacho'
import { Espelho } from 'components/Espelho'
import { useRequisicaoService } from 'hooks/useRequisicaoService'
const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.secondary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
  },
  actions: {
    margin: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  item: {
    padding: theme.spacing(1),
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  deleteButton: {
    marginLeft: 10,
    background: `linear-gradient(45deg, ${colors.red[900]} 30%, ${colors.red[800]} 90%)`,
    color: 'white',
  },
}))

export const MenuAcoes = ({ requisicao }) => {
  const router = useRouter()
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)
  const casoService = useCasoService()
  const [mensagensAlerta, setMensagensAlerta] = useState([])
  const [openAlert, setOpenAlert] = useState(false)
  const [openEspelhoDespacharObjetos, setOpenEspelhoDespacharObjetos] = useState(false)
  const [requisicaoDespachar, setRequisicaoDespachar] = useState(null)
  const [isDisabled, setIsDisabled] = useState(false)
  const [processandoDespachar, setProcessandoDespachar] = useState(false)
  const requisicaoService = useRequisicaoService()

  const handleClickBotaoAcoes = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleCloseAlert = () => {
    setMensagensAlerta([])
    setOpenAlert(false)
  }

  const handleClickCriarCasoComRequisicao = useCallback(async () => {
    const novasMensagensAlerta = []
    const caso = await casoService.listarCasoPorIdentificadorRIP(requisicao?.identificador_caso_rip)
    if (caso != null) {
      novasMensagensAlerta.push(`Já existe caso (${caso.identificador}) criado para esse RIP`)
    }
    if (requisicao?.status !== 'PENDENTE' || requisicao?.id_caso) {
      novasMensagensAlerta.push('Não é possível criar caso com requisição já relacionado a outro caso.')
    }
    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta.map((mensagem) => mensagem))
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
      router.history.push({
        pathname: `/casos/cadastrar/${requisicao.id}`,
        state: { requisicao },
      })
    }
  }, [requisicao, router.history])

  const handleClickDespacharRequisicao = useCallback(async () => {
    const result = await requisicaoService.despacharRequisicoes(requisicaoDespachar, requisicao.id, setProcessandoDespachar)

    if (result != null) {
      setIsDisabled(true)
      setOpenEspelhoDespacharObjetos(false)
      router.history.push('/requisicoes')
    } else {
      console.error('Erro ao despachar requisição')
    }
  }, [requisicao, requisicaoDespachar, router.history])

  const handleClickDespacharObjetos = async () => {
    const novasMensagensAlerta = []

    if (requisicao?.status !== 'PENDENTE' || requisicao?.id_caso) {
      novasMensagensAlerta.push('Requisição não pode ser despachada. Apenas requisições pendentes e sem caso relacionado podem ser despachadas.')
    }

    if (novasMensagensAlerta.length) {
      setMensagensAlerta(novasMensagensAlerta)
      setOpenAlert(true)
    } else {
      setMensagensAlerta([])
      setOpenEspelhoDespacharObjetos(true)
      setRequisicaoDespachar([])
      setAnchorEl(null)
      handleClose()
      setIsDisabled(false)
    }
  }

  return (
    <Grid alignItems="flex-end" container spacing={1}>
      <Grid item>
        <ButtonGroup aria-controls="customized-menu" className={classes.actions} aria-haspopup="true" variant="contained" color="primary">
          <Button onClick={handleClickBotaoAcoes} endIcon={<ArrowDropDownIcon />}>
            Ações
          </Button>
        </ButtonGroup>
        <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
          <>
            <StyledMenuItem onClick={handleClickCriarCasoComRequisicao}>
              <ListItemIcon>
                <AddCommentIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Criar caso relacionado" />
            </StyledMenuItem>

            <StyledMenuItem onClick={handleClickDespacharObjetos}>
              <ListItemIcon>
                <AssignmentTurnedInIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Despachar requisicao" />
            </StyledMenuItem>
          </>
        </StyledMenu>
      </Grid>
      <Espelho aberto={openEspelhoDespacharObjetos} disabled={isDisabled} setAberto={setOpenEspelhoDespacharObjetos} handleConfirmar={handleClickDespacharRequisicao} processando={processandoDespachar} titulo="DESPACHAR REQUISIÇÃO">
        <Grid item md={12} sm={12} xs={12} className={classes.item}>
          <SelectDespacho setoresSelecionados={requisicaoDespachar} setSetoresSelecionados={setRequisicaoDespachar} label="REQUISIÇÃO" multiplo={false} />
        </Grid>
      </Espelho>

      <Dialog open={openAlert} onClose={handleCloseAlert} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">Não é possível realizar a operação por não atender aos seguintes requisitos</DialogTitle>
        <DialogContent>
          {mensagensAlerta.map((mensagem) => (
            <DialogContentText>
              <Grid container spacing={2} alignItems="center">
                <Grid item md={1} sm={1} lg={1} xs={1}>
                  <ErrorOutlineIcon />
                </Grid>
                <Grid item md={11} sm={11} lg={11} xs={11}>
                  {mensagem}
                </Grid>
              </Grid>
            </DialogContentText>
          ))}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAlert} className={classes.deleteButton} autoFocus fullWidth>
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  )
}
